export const GET_ORDER_DETAIL_START = "GET_ORDER_DETAIL_START";
export const GET_ORDER_DETAIL_SUCCESS = "GET_ORDER_DETAIL_SUCCESS";
export const GET_ORDER_DETAIL_FAILURE = "GET_ORDER_DETAIL_FAILURE";
export const SEND_RESPONSE_START = "SEND_RESPONSE_START";
export const SEND_RESPONSE_SUCCESS = "SEND_RESPONSE_SUCCESS";
export const SEND_RESPONSE_FAILURE = "SEND_RESPONSE_FAILURE";
